import styled from 'styled-components'

const Grid = styled.div`
  display: grid;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  ${props => `
    max-width: ${props.maxWidth || 'unset'};
    width: ${props.width || 'unset'};
    grid-template-columns: ${props.columns || '1fr 1fr'};
  `};
`

const Item = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  color: #101123;
  padding: 12px 16px;
  font-size: 14px;
  line-height: 20px;
  word-break: break-word;
  ${props => `
  font-weight: ${props.fontWeight || '400'};
  flex-direction: ${props.direction || 'column'};
  justify-content: ${props.justifyContent || 'unset'};
  flex-basis: ${props.basis || 'unset'};
  align-items: ${props.alignItems || 'unset'};
  flex-wrap: ${props.wrap || 'unset'};
  gap: ${props.gap || 'unset'};
  `}

  &:nth-child(2n + 1) {
    border-right: 1px solid #e5e5e5;
  }

  &:nth-last-child(1),
  &:nth-last-child(2) {
    border-bottom: 0;
  }

  &:nth-child(4n),
  &:nth-child(4n-1) {
    background: #fcfcfc;
  }
`

export default Object.assign(Grid, {
  Item,
})
